import axios from 'axios'
import { invalidSession, setSentryError } from 'utils/logError'
import { DOMAIN } from 'constants/base'
import { getCookie, isEmpty, resolveKeysInObjectsArrays } from 'utils/browserHelper'

export const commonHeaders = {
    channel: 'desktop',
}

export const apiPostHelper = async (URL, PAYLOAD, contentType, requestHeaders) => {
    try {
        const ctAb = isEmpty(getCookie('ct-ab')) ? {} : JSON.parse(decodeURIComponent(getCookie('ct-ab')))

        let contentTypeText = 'application/json'
        if (contentType) {
            contentTypeText = contentType
        }
        let headers = {
            Accept: 'application/json',
            'Content-Type': contentTypeText,
            'Preferred-Language': getCookie('lp') || '',
            'ct-desktop': JSON.stringify({ h_exp_7: 'b' }),
            'app-agent': 'DESKTOP'
            // 'x-cookie': document && document.cookie, //Removed from here and added on the api calling method it self
        }
        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...commonHeaders,
                ...requestHeaders
            }
        }
        const responseData = await axios.post(URL, PAYLOAD, {
            headers
        })
        return responseData
    } catch (e) {
        invalidSession(e)
        //setSentryError(e)
        return {
            error: e
        }
    }
}

export const apiPostFormHelper = async (URL, PAYLOAD, header = {}) => {
    try {
        const responseData = await axios.post(URL, PAYLOAD, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...commonHeaders,
                ...header
            }
        })
        return responseData
    } catch (e) {
        invalidSession(e)
        //setSentryError(e)
        return e
    }
}

export const domain = resolveKeysInObjectsArrays(['location', 'origin'], window)

export const apiGetHelper = async (URL, contentType, requestHeaders= {}) => {
    try {
        let contentTypeText = 'text/plain;charset=UTF-8'
        if (contentType) {
            contentTypeText = contentType
        }

        let headers = {
            Accept: 'application/json',
            r_lang: getCookie('lp') || '',
            'Content-Type': contentTypeText,
            'Preferred-Language': getCookie('lp') || '',
            'app-agent': 'DESKTOP'
            // 'x-cookie': document && document.cookie,
        }
        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...commonHeaders,
                ...requestHeaders
            }
        }

        const responseData = await axios.get(URL, {
            headers
        })
        return responseData
    } catch (e) {
        invalidSession(e)
        //setSentryError(e)
        return e
    }
}

export const getWalletInfo = timeStamp => {
    try {
        const URL = `${DOMAIN}/partial/account/wallet?_=${timeStamp}`
        const header = {
            caller: domain
        }
        const response = apiGetHelper(URL, 'application/json', header)
        return response
    } catch (e) {
        console.error(e)
        logError(e)
    }
}

export const apiGetParamsHelper = async (URL, params, contentType) => {
    try {
        let contentTypeText = 'text/plain;charset=UTF-8'
        if (contentType) {
            contentTypeText = contentType
        }

        const responseData = await axios.get(URL, {
            headers: {
                Accept: 'application/json',
                r_lang: getCookie('lp') || '',
                'Content-Type': contentTypeText,
                ...commonHeaders,
            },
            params
        })
        return responseData
    } catch (e) {
        invalidSession(e)
        //setSentryError(e)
        // return e
    }
}

export const apiGetCurrency = async URL => {
    try {
        const responseData = await axios.get(URL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'text/plain;charset=UTF-8'
            }
        })
        return responseData
    } catch (e) {
        //setSentryError(e)
        // return e
    }
}

export const apiPutHelper = async (URL, PAYLOAD, contentType, requestHeaders) => {
    try {
        let contentTypeText = 'application/json; charset=UTF-8, text/html'
        if (contentType) {
            contentTypeText = contentType
        }
        let headers = {
            Accept: 'application/json',
            'Content-Type': contentTypeText,
            'Preferred-Language': getCookie('lp') || ''
        }
        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...commonHeaders,
                ...requestHeaders
            }
        }
        const responseData = await axios.put(URL, PAYLOAD, {
            headers
        })
        return responseData
    } catch (e) {
        invalidSession(e)
        //setSentryError(e)
        return {
            error: e
        }
    }
}

export const apiDeleteHelper = async (URL, contentType, requestHeaders) => {
    try {
        let contentTypeText = 'text/plain;charset=UTF-8'
        if (contentType) {
            contentTypeText = contentType
        }

        let headers = {
            Accept: 'application/json',
            r_lang: getCookie('lp') || '',
            'Content-Type': contentTypeText,
            'Preferred-Language': getCookie('lp') || ''
        }
        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...commonHeaders,
                ...requestHeaders
            }
        }

        const responseData = await axios.delete(URL, {
            headers
        })
        return responseData
    } catch (e) {
        invalidSession(e)
        //setSentryError(e)
        return e
    }
}
